<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="loanTypes.length">
				<span class="ml-2">فیلترها: </span>
				<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
						{{ loanType.title }}
						<v-badge color="blue" :content="loanType.id === 0 ? items.length : items.filter(x => x.loanModel.id == loanType.id).length || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="'لیست پرونده وام های نماینده'">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="filteredItems" :items-per-page="500" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td class="text-right">
								<div>
									<small>{{ row.item.memberModel.fullName }}</small>
								</div>
								<div>
									<small class="grey--text">{{ row.item.memberModel.nationalCode }}</small>
								</div>
							</td>
							<td class="text-right">
								<div>
									<small>شماره وام: </small>
									<small class="grey--text">{{ row.item.code }}</small>
								</div>
								<div>
									<small>عنوان وام: </small>
									<small class="grey--text">{{ row.item.loanModel.title }}</small>
								</div>
								<div>
									<small>تاریخ شروع: </small>
									<small class="grey--text">{{ row.item.startDate_Persian.date }}</small>
								</div>
								<div>
									<small>مبلغ وام: </small>
									<small class="grey--text">{{ row.item.amount.toString().toPriceFormat() }}</small>
								</div>
							</td>
							<td class="text-right">
								<div>
									<small>قابل پرداخت: </small>
									<small class="grey--text">{{ row.item.payableAmount.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>تعداد اقساط: </small>
									<small class="grey--text">{{ row.item.month }}</small>
								</div>
								<div>
									<small>مجموع اقساط پرداخت شده: </small>
									<small class="grey--text">{{ row.item.paid.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>مانده: </small>
									<small class="grey--text">{{ row.item.remain.toString().toPriceFormat() }}</small>
								</div>
							</td>
							<td class="text-right">
								<div v-if="agent.agentId">
									<small>نام نماینده: </small>
									<small class="grey--text">{{ row.item.agentModel.businessName }}</small>
								</div>
								<div>
									<small>سررسید تسویه: </small>
									<small class="grey--text">{{ row.item.agentDueDate_Persian ?
										row.item.agentDueDate_Persian.date : '' }}</small>
								</div>
								<div>
									<small>سهم نماینده: </small>
									<small class="grey--text">{{ row.item.agentPrice.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>مجموع واریز اسپانسر: </small>
									<small class="info--text" style="cursor: pointer;" @click="transactionList(row.item)">{{
										row.item.sumSponsorPayments.toString().toPriceFormat() }}</small>
								</div>
								<div class="text-center">
									<v-btn color="secondary" @click="transaction(row.item)" x-small>ثبت واریزی</v-btn>
								</div>
							</td>
							<td class="text-right" v-if="agent.agentId">
								<div>
									<small>سررسید تسویه: </small>
									<small class="grey--text">{{ row.item.subAgentDueDate_Persian ?
										row.item.subAgentDueDate_Persian.date : '' }}</small>
								</div>
								<div>
									<small>سهم زیرمجموعه: </small>
									<small class="grey--text">{{ row.item.subAgentPrice.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>مجموع واریز به زیرمجموعه: </small>
									<small class="info--text" style="cursor: pointer;" @click="subAgentTransactionList(row.item)">
										{{ row.item.sumParentAgentPayments.toString().toPriceFormat() }}
									</small>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>


		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'AgentUserLoans',
		props: {
			agent: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				localAgent: null,
				selectedTransaction: null,
				selectedUserLoan: null,
				dialogAgentTransactionsList: false,
				dialogSubAgentTransactionsList: false,
				dialogTransaction: false,
				errorMessages: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'مشخصات مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
						width: 170
					}, {
						text: 'کد ملی',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					}, {
						text: 'مشخصات وام',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 200
					}, {
						text: 'مشخصات بازپرداخت',
						align: 'start',
						sortable: true,
						value: 'paid',
						width: 250
					},
					{
						text: `${this.agent.agentId ? 'تسویه با نماینده سطح 1' : 'تسویه با نماینده'}`,
						align: 'center',
						sortable: true,
						value: 'agentDueDate_Persian',
						width: 220
					},
					{
						text: 'تسویه با نماینده زیرمجموعه',
						align: 'center',
						sortable: true,
						value: 'userLoan.subAgentDueDate_Persian',
						width: 250
					},
				],
				items: [],
				loanTypes: [],
				loanTypeFilter: '',
			}
		},
		mounted() {
			this.localAgent = this.agent
			if (!this.localAgent.agentId) {
				this.headers = this.headers.filter(x => x.value !== 'userLoan.subAgentDueDate_Persian')
			}
			this.loadData()
		},
		computed: {
			filteredItems() {
				if (!this.loanTypeFilter)
					return this.items
				let clonedItems = []
				clonedItems.push(...this.items)
				clonedItems = clonedItems.filter(x => this.loanTypeFilter.indexOf(x.loanModel.id) > -1)
				return clonedItems
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/userLoan/GetLoansByAgentId/' + this.agent.id, null)
					.then(response => {
						this.items = response
						this.loanTypes = Object.values(
							response.reduce((acc, obj) => ({ ...acc, [obj.loanModel.id]: obj.loanModel }), {})
						)
						if (this.loanTypes.length) {
							this.loanTypes.push({ id: 0, title: 'همه' })
							this.loanTypeFilter = 0
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			transaction(item) {
				if (item.agentModel)
					this.localAgent = item.agentModel

				this.selectedTransaction = {
					id: emptyId,
					paymentMethod: 2,
					isWithdraw: true,
					agent: {
						id: this.localAgent.id,
						businessName: this.localAgent.businessName,
						mobile: this.localAgent.mobile,
						firstName: this.localAgent.firstName,
						bankAccountsJson: this.localAgent.bankAccountsJson
					},
					userLoan: {
						id: item.id,
						title: `شماره وام: ${item.code}, عنوان: ${item.loanModel.title}`,
						code: item.code
					},
					amount: Math.max(item.agentPrice - item.sumSponsorPayments, 0),
					maxAmount: item.agentPrice - item.sumSponsorPayments
				}
				this.dialogTransaction = true
			},
			callbck_transaction(result) {
				this.dialogTransaction = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
			transactionList(userLoan) {
				if (userLoan.agentModel)
					this.localAgent = userLoan.agentModel
				this.selectedUserLoan = userLoan
				this.dialogAgentTransactionsList = true
			},
			subAgentTransactionList(userLoan) {
				this.selectedUserLoan = userLoan
				this.dialogSubAgentTransactionsList = true
			},
		},
	}
</script>
<style></style>
